import { useCallback } from "react";

import { useIntl } from "react-intl";

import BookletLogo from "images/random/booklet_2026.png";

import { PickingProductCard } from "./PickingProductCard";
import { useGiftQuantites } from "../hooks/usePickingMachineSelectors";
import { usePickingStore } from "../stores/usePickingStore";

export function Gift() {
  const intl = useIntl();

  const { picked, total } = useGiftQuantites();
  const handleClickProductCard = useCallback(() => {
    if (picked === total) {
      return;
    }
    usePickingStore.getState().incrementGiftQuantity();
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [picked, total]);

  return (
    <PickingProductCard
      itemId="itemId"
      imageUrl={BookletLogo}
      name={intl.formatMessage({ id: "components.picking.gift.product-card-title" })}
      pickedQuantity={picked}
      totalQuantity={total}
      hasBarcode={false}
      state={picked === total ? "DONE" : "IDLE"}
      onClickProductCard={handleClickProductCard}
    />
  );
}
